import fetchDownloads from './fetchDownloads';
import handleLanguages from './handleLanguages';
import handleTypes from './handleTypes';
import handlePagination from './handlePagination';

/**
 * Returns a callback to load data based on index and offset.
 * The data is then mapped to templates and passed to a masonry component.
 * @param {Element} component
 * @param {jQuery} $itemTemplate
 * @param {jQuery} $selectItemTemplate
 * @return {Function} A callback function
 */
const handleLoad = (component, $itemTemplate, $selectItemTemplate) => async () => {
    const $loader = $(component).find('.loader');
    const query = $(component).find('.downloads-list__search__input').val();

    // set loading flag
    $(component).attr('data-loading', true);
    $loader.attr('data-active', true);

    const url = $(component).attr('data-request-url');
    const method = $(component).attr('data-request-method');
    const param = $(component).attr('data-request-query-param');
    const resultContainerId = $(component).attr('data-initial-result-id') || 'initial-search-results';
    const $initialResults = $(`#${resultContainerId}`);
    const results = $initialResults.length
        ? $initialResults.get(0)
        : await fetchDownloads(url, method, { [param]: query });

    // filter download items from search results
    const entries = $(results).find('[data-type="download"]').get();
    // store results on component
    $(component).data('results', entries);
    // add selectable languages based on actual results
    handleLanguages(component, entries, $selectItemTemplate)();
    // add selectable downloadtype based on actual results
    handleTypes(component, entries, $selectItemTemplate)();
    // trigger pagination in order to render sliced results
    await handlePagination(component, $itemTemplate, true)();
    // unset loading flag
    $(component).attr('data-loading', false);
    // clear initial result
    if ($initialResults.length) $initialResults.remove();
};

export default handleLoad;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/handleLoad.js